import React from "react";
import cloud_mgmt_info from "../../assets/cloud_mgmt/cloud_mgmt_info.jpg";

const CloudMgmtInfo = () => {
  return (
    <div id="about">
      <div className="flex p-5 flex-col sm:flex-row">
        <div className="w-full sm:w-[35%]">
          <img src={cloud_mgmt_info} />
        </div>
        <div className="w-full sm:w-[60%]">
          <p className="font-notosans mt-5 mb-10">
            Cloud Management Services encompass the oversight, administration,
            and optimization of a company's cloud infrastructure. These services
            involve monitoring, provisioning, and maintaining resources on cloud
            platforms, ensuring optimal performance, security, and
            cost-effectiveness.
          </p>
          <div className="flex justify-between sm:flex-row flex-col gap-3">
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Minimize Risk and Improve ROI
            </div>
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Cost Saving in Cloud Bills
            </div>
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Reduction in Infrastructure Expenses
            </div>
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Free up your IT resources and maximum Guaranteed Uptime
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudMgmtInfo;
